import { AutofocusModule } from './autofocus/autofocus.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExampleComponent } from './example/example.component';


export class AppModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    BrowserModule,
    CommonModule,
    AutofocusModule
  ],
  declarations: [ExampleComponent],
  exports: [],
  bootstrap: [ExampleComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
